//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Input file ID
     */
    id: {
      type: String,
      default: 'file-uploader'
    },

    /**
     * Input file name
     */
    name: {
      type: String,
      default: 'file-uploader'
    },

    /**
     * The multiple attribute of the input tag whether to allow multiple files to be selected
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * The accept attribute of the input tag (MIME type)
     */
    accept: {
      type: String,
      default: ''
    },

    /**
     * Show dropzone
     */
    showDropzone: {
      type: Boolean,
      default: true
    },

    /**
     * The accept max file size
     */
    maxFileSize: {
      type: Number,
      default: 1024 * 1024 * 25
    },

    /**
     * Attribute tag contain files saved on database
     */
    value: {
      type: Array,
      default: () => {
        return []
      }
    },

    /**
     *  Endpoint address to do a post request
     */
    postAction: {
      type: String,
      default: '/mediaseed'
    },

    /**
     *  Required file upload
     */
    required: {
      type: Boolean,
      default: false
    },

    /**
     *  Disable file upload
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      uploading: false,
      files: []
    }
  },

  methods: {
    /**
     * Get file icon by type
     */
    getFileIcon(type) {
      try {
        const file = require(`~/assets/img/base/files/${type.toLowerCase()}.svg`)
        return file
      } catch (error) {
        return ''
      }
    },

    /**
     * Create new file
     */
    fileFactory(file) {
      return {
        ...file,
        progress: 0,
        error: false,
        cancelToken: null
      }
    },

    /**
     * On upload file to input
     */
    onUpload(event) {
      const { files } = event.target

      if (!this.multiple) {
        this.$emit('input', [])
        this.files = []
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const data = new FormData()
        const id = `${Date.now()}-${i}`
        const { name, size, type } = file
        const fileModel = this.fileFactory({ name, size, id, type })

        if (size > this.maxFileSize) {
          this.files.push({
            ...fileModel,
            error: {
              message: 'O arquivo é maior do que o tamanho máximo permitido'
            }
          })
        } else if (this.accept && !this.accept.includes(type)) {
          this.files.push({
            ...fileModel,
            error: {
              message: 'A extensão do arquivo não é um formato válido'
            }
          })
        } else {
          // Add file to files array
          this.files.push(fileModel)

          // Append file to FormData
          data.append('media', file)

          // Send file to API
          this.sendFile(id, data)
        }
      }

      this.$refs[this.id].value = ''
    },

    /**
     * Send binary file to API
     */
    sendFile(fileId, data) {
      const self = this
      const CancelToken = this.$axios.CancelToken

      this.uploading = true
      this.$axios
        .$post(this.postAction, data, {
          onUploadProgress(progressEvent) {
            self.onProgressChange(fileId, progressEvent)
          },
          cancelToken: new CancelToken(function executor(c) {
            self.setCancelToken(fileId, c)
          })
        })
        .then((res) => this.onSuccess(fileId, res))
        .catch((err) => this.onError(fileId, err))
    },

    /**
     * Set cancelable token inside file
     */
    setCancelToken(fileId, cancel) {
      this.files.map((file) => {
        if (file.id === fileId) file.cancelToken = cancel
        return file
      })
    },

    /**
     * Handle upload progress event
     */
    onProgressChange(fileId, progressEvent) {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )

      this.files.map((file) => {
        if (file.id === fileId) file.progress = percentCompleted
        return file
      })
    },

    /**
     * Handle error event when file returns from API
     */
    onError(fileId, error) {
      console.log('Error on upload file: ', error)

      let message = 'Não foi possível anexar o documento'

      if (error.message && !error.response) {
        message = error.message
      }

      this.files.map((file) => {
        if (file.id === fileId) {
          file.error = {
            message
          }
        }
        return file
      })

      this.uploading = false
    },

    /**
     * Handle success event when file returns from API
     */
    onSuccess(fileId, file) {
      this.value.push(file)
      this.$emit('input', this.value)

      const fileIndex = this.files.findIndex((file) => file.id === fileId)
      this.files.splice(fileIndex, 1)
      this.uploading = false
    },

    /**
     * Format size value of file. Default file size is displayed in byte.
     */
    formatSize(size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
      } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
      } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
      } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      }

      if (size) {
        return size.toString() + ' B'
      }
    },

    /**
     * Stop uploading the file being uploaded
     */
    onStop(media) {
      if (!media.error && media.progress !== 100) {
        media.cancelToken('Operação cancelada pelo usuário')
      } else {
        const fileIndex = this.files.findIndex((file) => file.id === media.id)
        this.files.splice(fileIndex, 1)
      }
    },

    /**
     * Remove uploaded file from medias
     */
    onRemove(media) {
      const fileIndex = this.value.findIndex((file) => file.id === media.id)
      this.value.splice(fileIndex, 1)
    }
  }
}
